import { graphql } from '@api/generated';

export const CONFIG_REVIEW_BANNER_STATE_QUERY = graphql(`
  query configReviewBanner {
    configReviewBanner {
      tenantBanners {
        tenantId
        tenantName
        adminReviewStatus
        agentReviewStatus
      }
    }
  }
`);
